<template>
  <div>
    <div class="content-wizard">
      <div class="row">
        <div v-if="!isRdvValidated"
             class="col-lg-12">
          <div class="m-t">
            <h3 class="font-bold">Créer le rendez-vous le {{ getRdvDate }} avec {{ command.saleRdvExpert.name }} au {{ addressToString }} ?</h3>
          </div>
          <div class="m-t">
            <p>L'acheteur, le vendeur ainsi que le partenaire seront notifiés.</p>
          </div>
        </div>
        <div v-else
             class="col-lg-12">
          <div class="m-t">
            <h3 class="font-bold">Le rendez-vous de cession est prévu le {{ getRdvDate }} avec {{ command.saleRdvExpert.name }} au {{ addressToString }}</h3>
          </div>
          <div class="m-t">
            <p>L’acheteur, le vendeur ainsi que le partenaire ont été notifiés.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button v-if="!isRdvValidated"
                type="button"
                class="pull-left btn btn-w-m btn-primary pull-right"
                @click="$parent.toggleBlock(3)">Précédent</button>
        <button v-if="!isRdvValidated"
                type="button"
                class="btn btn-w-m btn-primary pull-right"
                @click="onSubmit">Créer le rdv et notifier</button>
        <button v-else
                type="button"
                class="btn btn-w-m btn-danger pull-right"
                @click="deleteRdv">Replanifier ce rendez-vous de cession</button>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { addressToString } from '../../../helpers/utils'
  import { formatDateFull } from '../../../helpers/filters/filter'

  export default {
    props: {
      command: {
        type: Object,
        required: true
      },
      seller: {
        type: Object,
        required: true
      },

      owner: {
        type: Object,
        required: true
      },

      initialSaleRdv: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      isRdvValidated: false,
    }),

    computed: {
      addressToString () {
        return addressToString(this.initialSaleRdv.address)
      },

      getRdvDate () {
        if (this.initialSaleRdv.date) {
          return formatDateFull(this.initialSaleRdv.date).replace(/<br>/g, ' ')
        }
        return null
      },

      finalizeSaleRdvMutation () {
        return gql`
          mutation {
            finalizeSaleRdv (saleRdvId: "${this.initialSaleRdv.id}"){
            id
            result
            status
            }
          }`
      },

      cancelSaleRdvMutation () {
        return gql`
          mutation {
            cancelSaleRdv (saleRdvId: "${this.initialSaleRdv.id}"){
            id
            result
            status
            }
          }`
      }
    },

    mounted () {
      if (this.initialSaleRdv.status === "3") {
        this.isRdvValidated = true
      }
    },

    methods: {
      onSubmit () {
        this.$apollo.mutate({
          mutation: this.finalizeSaleRdvMutation
        }).then(() => {
          let newInitialSaleRdvValue = this.initialSaleRdv
          newInitialSaleRdvValue.status = '3'
          this.$emit('update-initialSaleRdv-value', newInitialSaleRdvValue)
          this.isRdvValidated = true

          this.showBanner('success', `Le rendez-vous à bien été planifié`)
        }, () => {
          this.showBanner('danger', `Les modifications n'ont pas été prises en compte.`)
        })
      },

      deleteRdv () {
        this.$apollo.mutate({
          mutation: this.cancelSaleRdvMutation
        }).then(() => {
          let newInitialSaleRdvValue = this.initialSaleRdv
          newInitialSaleRdvValue.status = '1'
          newInitialSaleRdvValue.address = null
          newInitialSaleRdvValue.date = null
          this.$emit('update-initialSaleRdv-value', newInitialSaleRdvValue)

          this.$parent.toggleBlock(1)
          this.command.saleRdvExpert.name = null
        }, () => {
          this.showBanner('danger', `Les modifications n'ont pas été prises en compte.`)
        })
      }
    }
  }
</script>
